import { GameEvent } from '@/types'
import { MessageAction, OutcomingMessage } from '@/modules/main-frame/message-types'

export class PlatformService {
    constructor(private readonly currentLanguage: string) {}

    handleMessage(event: GameEvent): OutcomingMessage {
        switch (event.data.action) {
            case MessageAction.getPlatformInfo: {
                return {
                    action: MessageAction.platformInfo,
                    originalMessageEvent: event as GameEvent,
                    payload: {
                        language: this.currentLanguage,
                    },
                }
            }

            default:
                return {
                    action: MessageAction.unknownMessageType,
                    originalMessageEvent: event as GameEvent,
                    payload: {
                        error: `Unknown message action "${event.data.action}"`,
                    },
                    type: 'error',
                }
        }
    }
}
